<template>
  <div :class="is_en ? 'solution2 en' : 'solution2'">
    <el-menu
      default-active="0"
      active-text-color="#FF6B35"
      @select="handleSelect"
      class="el-menu-vertical-demo">
      <el-menu-item  v-for="(item, index) in list" :index="String(index)">
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-menu>
    <div :class="contentClass">
      <el-card shadow="hover">
        <div class="card">
          <div class="card-left">
            <div class="title">
              {{ list[activeIndex].title }}
            </div>
            <div class="desc">
              {{ list[activeIndex].desc }}
            </div>
            <div class="title">
              {{ list[activeIndex].title2 }}
            </div>
            <div class="desc2">
              {{ list[activeIndex].desc2 }}
            </div>
<!--            <div class="list">-->
<!--              <div class="item" v-html="$t('industryItems.automotive')"></div>-->
<!--              <div class="item" v-html="$t('industryItems.mobile')"></div>-->
<!--              <div class="item" v-html="$t('industryItems.homeAppliance')"></div>-->
<!--              <div class="item" v-html="$t('industryItems.communication')"></div>-->
<!--              <div class="item" v-html="$t('industryItems.medical')"></div>-->
<!--              <div class="item" v-html="$t('industryItems.digital')"></div>-->
<!--            </div>-->
          </div>
          <div class="img">
            <img class="img2" :src="is_en ? img_en : list[activeIndex].img2" alt="">
          </div>
        </div>
      </el-card>
      <div style="height: 30px"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "solution2",
  data() {
    return {
      contentClass: 'content',
      activeIndex: 0,
      img_en: require('@/assets/solution2/all2.jpeg')
    }
  },
  computed: {
    is_en() {
      return this.$t('language') === 'English'
    },
    list() {
      return [
        {
          title: this.$t('solution2.india.title'),
          title2: this.$t('solution2.india.title2'),
          desc: this.$t('solution2.india.desc'),
          desc2: this.$t('solution2.india.desc2'),
          img1: require('@/assets/solution2/yindu1.png'),
          img2: require('@/assets/solution2/印度.jpg'),
          img3: require('@/assets/solution2/yindu3.png')
        },
        {
          title: this.$t('solution2.southeast_asia.title'),
          title2: this.$t('solution2.southeast_asia.title2'),
          desc: this.$t('solution2.southeast_asia.desc'),
          desc2: this.$t('solution2.southeast_asia.desc2'),
          img1: require('@/assets/solution2/dong1.png'),
          img2: require('@/assets/solution2/东南亚.jpg'),
          img3: require('@/assets/solution2/dong3.png')
        },
        {
          title: this.$t('solution2.europe.title'),
          title2: this.$t('solution2.europe.title2'),
          desc: this.$t('solution2.europe.desc'),
          desc2: this.$t('solution2.europe.desc2'),
          img1: require('@/assets/solution2/ou1.png'),
          img2: require('@/assets/solution2/欧洲.jpg'),
          img3: require('@/assets/solution2/ou3.png')
        },
        {
          title: this.$t('solution2.america.title'),
          title2: this.$t('solution2.america.title2'),
          desc: this.$t('solution2.america.desc'),
          desc2: this.$t('solution2.america.desc2'),
          img1: require('@/assets/solution2/mei1.png'),
          img2: require('@/assets/solution2/美洲.jpg'),
          img3: require('@/assets/solution2/mei3.png')
        },
        {
          title: this.$t('solution2.oceanica.title'),
          title2: this.$t('solution2.oceanica.title2'),
          desc: this.$t('solution2.oceanica.desc'),
          desc2: this.$t('solution2.oceanica.desc2'),
          img1: require('@/assets/solution2/ao1.png'),
          img2: require('@/assets/solution2/大洋洲.jpg'),
          img3: require('@/assets/solution2/ao3.png')
        }
      ];
    }
  },
  methods: {
    handleSelect(index, indexPath) {
      this.contentClass = 'content'
      setTimeout(() => {
        this.activeIndex = index
        this.contentClass = 'content slide-element'
      }, 200)
    }
  },
  mounted() {
    this.handleSelect(this.activeIndex)
  }
}
</script>

<style lang="scss">
.solution2 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-left: 150px;
  line-height: 2;
  min-height: calc(100vh - 60px - 60px);
  &.en {
    padding-left: 220px;
    .el-menu-vertical-demo {
      width: 220px;
      .el-menu-item {
        white-space: normal;
        line-height: normal; /* 调整行高 */
      }
    }
    .content .img2 {
      top: -67px;
      right: -40px;
    }
    .list .item {
      border-radius: 10px;
      width: 90px;
      font-size: 13px;
    }
  }
  .el-menu-vertical-demo {
    position: absolute;
    left: 0;
    top: 30px;
    width: 150px;
    border-left: solid 1px #e6e6e6;
    border-right: 0;
    .el-menu-item:focus,.el-menu-item:hover {
      background-color: #FFEFE9;
    }
    .el-menu-item {
      position: relative;
      color: #999;
    }
    .el-menu-item.is-active {
      font-weight: 700;
    }
    .el-menu-item.is-active:before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 3px;
      height: 100%;
      background: #FF6B35;
    }
  }
  .content {
    padding: 30px 0 30px 40px;
    .el-card__body {
      padding: 0;
    }
    .card {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 10;
    }
    .card-left {
      position: relative;
      z-index: 10;
      padding: 30px 40px 30px 40px;
      margin-right: 150px;
      background: #FFF9F7;
      min-height: 350px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 400px;
    }
    .title {
      font-size: 20px;
      color: #FF6B35;
      padding-bottom: 20px;
      text-align: center;
    }
    .desc {
      font-size: 14px;
      padding-bottom: 20px;
    }
    .img {
      flex: 1;
      height: 350px;
      position: relative;
    }
    .img2 {
      position: absolute;
      width: 750px;
      top: -67px;
      right: -80px;
      z-index: 1;
    }
    .desc2 {
      font-size: 14px;
      padding-bottom: 20px;
      color: #FF6B35;
    }
  }
  .list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    .item {
      text-align: center;
      padding: 10px;
      box-sizing: content-box;
      width: 50px;
      height: 50px;
      border-radius: 50px;
      border:1px solid #FF6B35;
      color: #FF6B35;
      background: #ffffff;
      line-height: 1.2;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
  }
}
</style>